// Webpack-bundled candidate photos, keyed by slug.
// Importing from src/assets means these are hashed & bundled at build time,
// so they load reliably across navigation (unlike string paths into /public).
// GENERATED by the add-kandidat skill — derived from src/data/candidates.json.
import asmawati from './kandidat/asmawati.jpeg';
import sitiRokayah from './kandidat/siti-rokayah.jpeg';
import yayuSrirahayu from './kandidat/yayu-srirahayu.jpeg';
import windiSintiani from './kandidat/windi-sintiani.jpeg';
import anjalniOktaviani from './kandidat/anjalni-oktaviani.jpeg';
import alHikmahNurAzizah from './kandidat/al-hikmah-nur-azizah.jpeg';
import oktaDamayanti from './kandidat/okta-damayanti.jpeg';
import wiwiSahara from './kandidat/wiwi-sahara.jpeg';
import amandaFebihaniRamadian from './kandidat/amanda-febihani-ramadian.jpeg';
import maryanti from './kandidat/maryanti.jpeg';
import sitiRohibah from './kandidat/siti-rohibah.jpeg';
import novaSriYuniar from './kandidat/nova-sri-yuniar.jpeg';
import dedeSopiah from './kandidat/dede-sopiah.jpeg';
import sitiYuniNurrahmawati from './kandidat/siti-yuni-nurrahmawati.jpeg';
import yayukSusanti from './kandidat/yayuk-susanti.jpeg';
import turaesin from './kandidat/turaesin.jpeg';
import auliaYuningsih from './kandidat/aulia-yuningsih.jpeg';
import sitiFitriRohani from './kandidat/siti-fitri-rohani.jpeg';
import khaniaNovaAfifah from './kandidat/khania-nova-afifah.jpeg';
import diniRismaYanti from './kandidat/dini-risma-yanti.jpeg';
import lusianaPasaribu from './kandidat/lusiana-pasaribu.jpeg';

const candidateImages = {
  'asmawati': asmawati,
  'siti-rokayah': sitiRokayah,
  'yayu-srirahayu': yayuSrirahayu,
  'windi-sintiani': windiSintiani,
  'anjalni-oktaviani': anjalniOktaviani,
  'al-hikmah-nur-azizah': alHikmahNurAzizah,
  'okta-damayanti': oktaDamayanti,
  'wiwi-sahara': wiwiSahara,
  'amanda-febihani-ramadian': amandaFebihaniRamadian,
  'maryanti': maryanti,
  'siti-rohibah': sitiRohibah,
  'nova-sri-yuniar': novaSriYuniar,
  'dede-sopiah': dedeSopiah,
  'siti-yuni-nurrahmawati': sitiYuniNurrahmawati,
  'yayuk-susanti': yayukSusanti,
  'turaesin': turaesin,
  'aulia-yuningsih': auliaYuningsih,
  'siti-fitri-rohani': sitiFitriRohani,
  'khania-nova-afifah': khaniaNovaAfifah,
  'dini-risma-yanti': diniRismaYanti,
  'lusiana-pasaribu': lusianaPasaribu,
};

export default candidateImages;
